// @ts-ignore: TypeScript cannot recognize *.md dependencies
import changelog from '../CHANGELOG.md';

document.body.innerHTML = changelog;